import { Link, useLocation } from 'react-router-dom';
import React, { useContext, useState, useEffect } from 'react';
import { RxExit, RxDashboard } from "react-icons/rx";
import { IoPersonAddOutline } from "react-icons/io5";
import { FaChartBar } from "react-icons/fa";
import { AuthContext } from "../../context/Auth";

export const Sidebar = () => {
  const { signOut } = useContext(AuthContext);
  const location = useLocation();
  const [activePage, setActivePage] = useState('');

  useEffect(() => {
    setActivePage(location.pathname);
  }, [location.pathname]);

  // Links de navegação
  const navLinks = [
    { to: '/dashboard', label: 'Dashboard', icon: <RxDashboard size={23} /> },
    { to: '/collaborator', label: 'Colaboradores', icon: <IoPersonAddOutline size={23} /> },
    { to: '/reports', label: 'Relatórios', icon: <FaChartBar size={23} /> },
  ];

  return (
    <>
      {/* Header mobile */}
      <header className="lg:hidden fixed top-0 left-0 w-full bg-black text-white z-40 shadow flex items-center justify-between px-4 py-3">
        <nav className="flex items-center space-x-4">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`flex items-center px-2 py-1 rounded hover:bg-gray-800 transition-colors ${activePage === link.to ? 'text-indigo-400' : ''}`}
            >
              {link.icon}
              <span className="ml-2 text-sm font-medium">{link.label}</span>
            </Link>
          ))}
        </nav>
        <button
          onClick={signOut}
          className="ml-2 bg-red-500 hover:bg-red-700 text-white px-3 py-2 rounded transition-colors text-sm flex items-center"
        >
          <RxExit size={20} className="mr-1" /> Sair
        </button>
      </header>

      {/* Sidebar desktop */}
      <section className="hidden lg:flex min-h-screen w-20 hover:w-32 transition-all bg-black justify-center fixed lg:relative z-30">
        <nav className="items-center flex flex-col content-between py-12 h-full">
          <ul>
            {navLinks.map(link => (
              <li key={link.to} className='list-none p-2.5 mt-5 text-white rounded-sm'>
                <Link to={link.to} className="flex items-center justify-center">
                  {link.icon}
                </Link>
              </li>
            ))}
          </ul>
          <button onClick={signOut} className="text-white mx-auto border-none p-2 rounded-sm fixed lg:relative bottom-4 lg:bottom-auto lg:top-3/4 mt-10 "><RxExit color="white" size={23}/></button>
        </nav>
      </section>
      {/* Espaço para compensar o header mobile */}
      <div className="lg:hidden h-16" />
    </>
  );
}